var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M12.7065 10.3105L0.00378418 2.74023V16.2789C0.00378418 17.5151 0.927387 18.5266 2.05624 18.5266H23.3628C24.4917 18.5266 25.4153 17.5151 25.4153 16.2789V2.88569L12.7065 10.3105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M12.7126 8.68931L25.0667 1.47176C24.6973 0.87066 24.0704 0.473145 23.3628 0.473145H2.05627C1.39154 0.473145 0.798184 0.824106 0.422485 1.36495L12.7126 8.68931Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMailIcon);
export default __webpack_public_path__ + "static/media/dark_mail_icon.5c2176fc8c7014384dd01da160ff6839.svg";
export { ForwardRef as ReactComponent };